import { Link, useLocation } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import { pathForLang } from "../lib/routing";

/**
 * Cambiar de idioma es navegar a la URL del otro idioma, no mutar estado:
 * así cada versión es una página real que Google puede indexar, y son <a>
 * de verdad, con href, que el crawler puede seguir.
 */
export default function LanguageToggle() {
  const { lang } = useI18n();
  const { pathname } = useLocation();

  const cell = (code, label) => {
    const active = lang === code;
    const cls = `px-2.5 py-1.5 ${active ? "bg-ember text-charred" : ""}`;
    return active ? (
      <span className={cls} aria-current="true">{label}</span>
    ) : (
      <Link to={pathForLang(pathname, code)} className={cls} hrefLang={code}
            aria-label={code === "es" ? "Ver en español" : "View in English"}>
        {label}
      </Link>
    );
  };

  return (
    <div
      data-testid="lang-toggle-btn"
      className="inline-flex items-center gap-0 border border-ember/40 text-xs uppercase tracking-[0.24em] font-medium text-ember hover:border-ember transition-colors"
    >
      {cell("es", "ES")}
      {cell("en", "EN")}
    </div>
  );
}
